export const partners = {
 reset: {
   password: {
     placeholder: {
       login_id: 'ご登録済みのログインID'
     }
   }
 }
}
